import { useDispatch, useSelector } from "react-redux";
import { getLocale, history, getFeatureToggle } from "../../../common/helpers";
import { ProfileModalWrapper } from "./styles";
import { userActions } from "../../../user/Actions";
import { activationPopupConstants } from "../../constants";
import { Link } from "react-router-dom";
import { userConstants } from "../../../user/Constants";
import { decryptData, encryptData } from "../../../common/utils/jsUtils";
import { includesInString } from "../../../common/utils";
import { useTranslation } from "react-i18next";
import { useComponentVisible } from "../utils";
import { USER_TYPE_OBJ_CONSTANT } from "../../../team/constants";

const ProfileModal = () => {
  const { t } = useTranslation();
  const language = getLocale(history.location.pathname, true);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.login);
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    null;
  const isAdminUser =
    currentUser?.roleId === USER_TYPE_OBJ_CONSTANT.ADMINISTRATOR[1] ||
    currentUser?.roleId === USER_TYPE_OBJ_CONSTANT.INDIVIDUAL_USER[1];
  const isEuDataActEnabled = getFeatureToggle("EU Data Act")[0]?.isVisible ?? false;

  const showActivationPopUp = () => {
    dispatch({
      type: activationPopupConstants.SHOW_ACTIAVTION_POPUP,
      showActivationPopup: true,
    });
  };

  const showEditProfilePopUp = () => {
    dispatch({
      type: userConstants.SHOW_EDIT_PROFILE_POPUP,
      showEditProfilePopUp: true,
    });
  };

  const showChangePasswordPopUp = () => {
    dispatch({
      type: userConstants.SHOW_CHANGE_PASSWORD_POPUP,
      showChangePasswordPopUp: true,
    });
  };

  const showGiveFeedbackPopUp = () => {
    dispatch({
      type: userConstants.SHOW_GIVEFEEDBACK_POPUP,
      showGiveFeedbackPopUp: true,
    });
  };
  const deleteCookie = (cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };
  const signOut = () => {
    let featuresToggles = JSON.parse(decryptData(localStorage.getItem("featuresToggles")));
    dispatch(userActions.logout());
    localStorage.clear();
    deleteCookie('user');
    localStorage.setItem("featuresToggles", encryptData(JSON.stringify(featuresToggles)));
    window.location.reload(true);
  };

  const showMyNotificationsPopUp = () => {
    dispatch({
      type: userConstants.SHOW_MY_NOTIFICATIONS_POPUP,
      showMyNotificationsPopUp: true,
    });
  };

  const { ref, isComponentVisible } = useComponentVisible(true);

  return (
    <>
      <ProfileModalWrapper>
        <div ref={ref}>
          {isComponentVisible && (
            <div className="profile-modal-backdrop">
              <div className="profile-modal">
                <ul className="user-options-list">
                  <li className="user-options-list-item">
                    <Link
                      onClick={() => {
                        history.push(language + "/settings");
                      }}
                      to={language + "/settings"}
                      className="user-options-list-item-link"
                    >
                      {t("Settings")}
                    </Link>
                  </li>
                  <li
                    onClick={showMyNotificationsPopUp}
                    className="user-options-list-item"
                  >
                    <span className="user-options-list-item-link">
                      {t("My Notifications")}
                    </span>
                  </li>
                  <li
                    className="user-options-list-item"
                    onClick={showActivationPopUp}
                  >
                    <span className="user-options-list-item-link">
                      {t("Activate Product")}
                    </span>
                  </li>
                  <li
                    onClick={showEditProfilePopUp}
                    className="user-options-list-item"
                  >
                    <span className="user-options-list-item-link">
                      {t("Edit Profile")}
                    </span>
                  </li>
                  <li
                    onClick={showChangePasswordPopUp}
                    className="user-options-list-item"
                  >
                    <span className="user-options-list-item-link">
                      {t("Change Password")}
                    </span>
                  </li>
                  {isEuDataActEnabled && isAdminUser && (
                    <li className="user-options-list-item">
                      <Link
                        to={language + "/data-privacy"}
                        className="user-options-list-item-link"
                      >
                        {t("Data & Privacy")}
                      </Link>
                    </li>
                  )}
                  <li
                    onClick={showGiveFeedbackPopUp}
                    className="user-options-list-item"
                  >
                    <span className="user-options-list-item-link">
                      Give Feedback
                    </span>
                  </li>
                  <li onClick={signOut} className="user-options-list-item">
                    <div className="user-options-list-item-link">
                      <span>
                        {t("Sign out")}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </ProfileModalWrapper>
    </>
  );
};

export default ProfileModal;
